import React, { useEffect, useState, useCallback } from 'react';
import api from '../api';
import { Header } from './Dashboard';

const EMPTY = { title: '', imageUrl: '', link: '', placement: 'explore', active: true, order: 0 };

export default function Banners() {
  const [banners, setBanners] = useState([]);
  const [form, setForm] = useState({ ...EMPTY });
  const [editingId, setEditingId] = useState(null);

  const load = useCallback(async () => {
    const data = await api.get('/admin/banners');
    setBanners(data.banners);
  }, []);
  useEffect(() => { load(); }, [load]);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    if (!form.title) return;
    if (editingId) await api.patch(`/admin/banners/${editingId}`, form);
    else await api.post('/admin/banners', form);
    setForm({ ...EMPTY });
    setEditingId(null);
    load();
  };

  const edit = (b) => { setForm({ title: b.title, imageUrl: b.imageUrl, link: b.link, placement: b.placement, active: b.active, order: b.order }); setEditingId(b._id); };
  const remove = async (id) => { if (window.confirm('Delete banner?')) { await api.del(`/admin/banners/${id}`); load(); } };

  return (
    <div>
      <Header title="Content & Banners" sub="Promotional banners shown across the app" />
      <div style={styles.layout}>
        <div className="card" style={{ height: 'fit-content' }}>
          <h3 style={{ marginTop: 0 }}>{editingId ? 'Edit Banner' : 'New Banner'}</h3>
          <Field label="Title"><input className="input" value={form.title} onChange={(e) => set('title', e.target.value)} /></Field>
          <Field label="Image URL"><input className="input" value={form.imageUrl} onChange={(e) => set('imageUrl', e.target.value)} placeholder="https://…" /></Field>
          <Field label="Link (optional)"><input className="input" value={form.link} onChange={(e) => set('link', e.target.value)} /></Field>
          <Field label="Placement">
            <select className="input" value={form.placement} onChange={(e) => set('placement', e.target.value)}>
              <option value="explore">Explore (app)</option>
              <option value="home">Home (app)</option>
              <option value="premium">Premium (app)</option>
              <option value="website">Website (landing top banner)</option>
            </select>
          </Field>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text-dim)', fontSize: 14, marginBottom: 14 }}>
            <input type="checkbox" checked={form.active} onChange={(e) => set('active', e.target.checked)} /> Active
          </label>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn" onClick={save}>{editingId ? 'Update' : 'Add Banner'}</button>
            {editingId ? <button className="btn ghost" onClick={() => { setForm({ ...EMPTY }); setEditingId(null); }}>Cancel</button> : null}
          </div>
        </div>

        <div style={styles.list}>
          {banners.map((b) => (
            <div key={b._id} className="card" style={{ padding: 0, overflow: 'hidden' }}>
              {b.imageUrl ? <img src={b.imageUrl} alt={b.title} style={styles.bannerImg} /> : <div style={{ ...styles.bannerImg, background: 'var(--card-alt)' }} />}
              <div style={{ padding: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <strong>{b.title}</strong>
                  <span className={`badge ${b.active ? 'active' : 'incomplete'}`}>{b.active ? 'Active' : 'Hidden'}</span>
                </div>
                <div style={{ color: 'var(--text-muted)', fontSize: 12, margin: '6px 0 12px', textTransform: 'capitalize' }}>📍 {b.placement}</div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button className="btn sm muted" onClick={() => edit(b)}>Edit</button>
                  <button className="btn sm danger" onClick={() => remove(b._id)}>Delete</button>
                </div>
              </div>
            </div>
          ))}
          {banners.length === 0 ? <p style={{ color: 'var(--text-muted)' }}>No banners yet.</p> : null}
        </div>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div style={{ marginBottom: 12 }}>
      <label style={{ display: 'block', color: 'var(--text-dim)', fontSize: 13, fontWeight: 600, marginBottom: 6 }}>{label}</label>
      {children}
    </div>
  );
}

const styles = {
  layout: { display: 'grid', gridTemplateColumns: '340px 1fr', gap: 20, alignItems: 'start' },
  list: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 16 },
  bannerImg: { width: '100%', height: 130, objectFit: 'cover' },
};
